import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    reference: {
      id: 'batch.reference',
      defaultMessage: 'Reference',
      description: 'Label of the batch property reference',
    },
    action: {
      id: 'batch.action',
      defaultMessage: 'Action',
      description: 'Label of the batch property action',
    },
    dataset: {
      id: 'batch.dataset',
      defaultMessage: 'Dataset',
      description: 'Label of the batch property dataset',
    },
    isImport: {
      id: 'batch.isImport',
      defaultMessage: 'Import',
      description: 'Label of the batch property is import',
    },
    isAccepted: {
      id: 'batch.isAccepted',
      defaultMessage: 'Accepted',
      description: 'Label of the batch property is accepted',
    },
    isConfirmed: {
      id: 'batch.isConfirmed',
      defaultMessage: 'Confirmed',
      description: 'Label of the batch property is confirmed',
    },
    isReady: {
      id: 'batch.isReady',
      defaultMessage: 'Ready',
      description: 'Label of the batch property is ready',
    },
    isFailing: {
      id: 'batch.isFailing',
      defaultMessage: 'Failed',
      description: 'Label of the batch property is failing',
    },
  },
};

export default defineMessages(translations);
